import { axiosAjax } from '@app/src/config/axios';
import { getSettings } from '@app/src/configuration/config.service';

export const serviceLogout = {
  async logout() {
    try {
      const userId = sessionStorage.getItem('idUser');
      const token = sessionStorage.getItem('accessToken');

      await axiosAjax.delete(`${ getSettings().API_LOGOUT}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { userId } // <- Aquí se coloca el cuerpo en una petición DELETE
      });
    } catch (e) {
      console.error('Error al cerrar sesión:', e.response?.data || e.message);
    }
  }
};
